<template>
  <div class="parkStatistic">
    <div class="bg-light pd-shadow p-bg">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/pageAuthority' }">页面权限配置</el-breadcrumb-item>
        <el-breadcrumb-item>{{fid? "编辑":"新增"}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bg-form-content">
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="form-body form-label-150">
        <el-form-item label="菜单类型" >
          <el-radio-group v-model="dataForm.type">
            <el-radio :label="1">一级菜单</el-radio>
            <el-radio :label="2">二级菜单</el-radio>
            <el-radio :label="3">三级菜单</el-radio>
            <el-radio :label="4">四级菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="功能菜单名称" prop="fname">
          <el-input v-model="dataForm.fname" type="text" placeholder="请输入功能菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="功能菜单别名" prop="nikefname">
          <el-input v-model="dataForm.nikefname" type="text" placeholder="请输入功能菜单别名"></el-input>
        </el-form-item>
        <el-form-item label="一级菜单" v-if="dataForm.type == 1">
          <el-input v-model="dataForm.parentRoot" :disabled="true" placeholder="请输入别名"></el-input>
        </el-form-item>
        <el-form-item label="一级菜单" prop="parentRoot1" v-if="dataForm.type >= 2 ">
          <el-select v-model="dataForm.parentRoot1" size="small" placeholder="功能菜单类型" @change="changeRoot1">
            <el-option v-for="(item,index) in parentRootList" :key="index" :label="item.fname" :value="item.fid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级菜单" prop="parentRoot2" v-if="dataForm.type >= 3">
          <el-select v-model="dataForm.parentRoot2" size="small" placeholder="功能菜单类型" @change="changeRoot2">
            <el-option v-for="(item,index) in parentRootTwoList" :key="index" :label="item.fname" :value="item.fid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="三级菜单" prop="parentRoot3" v-if="dataForm.type == 4">
          <el-select v-model="dataForm.parentRoot3" size="small" placeholder="功能菜单类型">
            <el-option v-for="(item,index) in parentRoothreeList" :key="index" :label="item.fname" :value="item.fid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="idx">
          <el-input v-model="dataForm.idx" type="number" placeholder="请输入排序号"></el-input>
        </el-form-item>
        <el-form-item label="URL">
          <el-input v-model="dataForm.url" type="text" placeholder="请输入URL"></el-input>
        </el-form-item>
        <el-form-item label="图标名称">
          <el-input v-model="dataForm.iconName" type="text" placeholder="请输入图标名称"></el-input>
        </el-form-item>
        <el-form-item label="样式">
          <el-input v-model="dataForm.style" type="text" placeholder="请输入样式"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="close()">取消</el-button>
          <el-button type="primary" @click="submitForm('dataForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "addPageAuth",
  watch: {},
  data() {
    return {
      parentRootList: [],
      parentRootTwoList: [],
      parentRoothreeList: [],
      fid: this.$route.query.fid || "",
      dataForm: {
        parentRoot1: "",
        parentRoot2: "",
        parentRoot3: "",
        fname: "",
        parentRoot: "0",
        iconName: "",
        idx: "",
        nikefname: "",
        style: "",
        type: 1,
        url: ""
      },
      rules: {
        nikefname: [
          { required: true, message: "请输入功能菜单别名", trigger: "blur" }
        ],
        fname: [
          { required: true, message: "请输入功能菜单名称", trigger: "blur" }
        ],
        idx: [{ required: true, message: "请输入排序号", trigger: "blur" }],
        parentRoot1: [
          { required: true, message: "请选择一级菜单", trigger: "change" }
        ],
        parentRoot2: [
          { required: true, message: "请选择二级菜单", trigger: "change" }
        ],
        parentRoot3: [
          { required: true, message: "请选择三级菜单", trigger: "change" }
        ]
      }
    };
  },
  created() {
    if (this.fid) {
      this.getUserInfo();
    } 
    this.parentRoot(0,1);
  },
  watch:{ 
  },
  methods: {
    changeRoot1(){
       this.parentRoot(this.dataForm.parentRoot1, 2);
        this.dataForm.parentRoot2 = ''
    },
    changeRoot2(){
       this.parentRoot(this.dataForm.parentRoot2, 3);
        this.dataForm.parentRoot3 = ''
    },
    getUserInfo() {
      this.$http.post(this.$api.systemManageApi.getFunctionInfo(), { fid: this.fid}).then(res => {
        if (!res) {
          return;
        }
        this.dataForm = {
          parentRoot1: res.data.oneFid,
          parentRoot2: res.data.twoFid,
          parentRoot3: res.data.threeFid,
          fname: res.data.fname,
          parentRoot: 0,
          iconName:res.data.iconName,
          idx: res.data.idx,
          nikefname: res.data.nikefname,
          style: res.data.style,
          type: parseInt(res.data.type),
          url: res.data.url
        }
        if(res.data.type == 3){
          this.parentRoot(this.dataForm.parentRoot1, 2);
        }
        if(res.data.type == 4){
          this.parentRoot(this.dataForm.parentRoot2, 3);
          this.parentRoot(this.dataForm.parentRoot1, 2);
        }
      });
    },
    //获取菜单LIST  type  1：一级菜单   2：二级菜单  3 三级菜单
    parentRoot(id, type) {
      this.$http
        .post(this.$api.systemManageApi.getSubFunctionList(), { parentRoot: id })
        .then(res => {
          if (type === 1) this.parentRootList = res.data.subFunctionList;
          else if (type === 2)
            this.parentRootTwoList = res.data.subFunctionList;
          else if (type === 3)
            this.parentRoothreeList = res.data.subFunctionList;
        });
    },
    close() {
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          this.$model.toast("验证失败！", "error");
          return false;
        }
      });
    },
    save() {
      let data = { ...this.dataForm };
      if (this.dataForm.type == 1) data.parentRoot = 0;
      else if (this.dataForm.type == 2) data.parentRoot = data.parentRoot1;
      else if (this.dataForm.type == 3) data.parentRoot = data.parentRoot2;
      else if (this.dataForm.type == 4) data.parentRoot = data.parentRoot3;
      if(this.fid) data.fid = this.fid;
      this.$http.post(this.$api.systemManageApi.saveFunctionInfo(), data).then(res => {
        if (!res) {
          return;
        }
        this.$model.toast("操作成功！", "success");
        this.$router.go(-1);
      });
    }
  }
};
</script>
<style lang="sass" scoped>

</style>


